import Vue from 'vue'
import * as $api from './ServerApi.js'

export const State = Vue.observable({
  user: {},
  footer: {
    name: '',
    address: '',
    tel: '',
    email: '',
    service_time: ''
  },
  cart: [],
  ShopName: '',
  cartCounter: 0,
  topClassify: [],
  currPageName: ''
})

const bus = new Vue({
  computed: {
    webTitle () {
      return [State.ShopName, State.currPageName].join('-')
    }
  },
  watch: {
    webTitle () {
      document.title = this.webTitle
    }
  }
})

bus.$on('update:user', async callback => {
  let user = {}
  try {
    const { data } = await $api.loginState()
    user = data
  } catch (err) {
    console.log(err)
  }
  State.user = user
  if (callback) callback(user)
  bus.$emit('updated:user')
})

bus.$on('update:cart', fetchCart)

async function fetchCart () {
  const { data } = await $api.getCart()
  State.cartCounter = data.length
  State.cart = data
  bus.$emit('updated:cart', data)
}

async function fetchFooter () {
  const { data: footer } = await $api.getFooter()
  State.footer = footer
  State.ShopName = footer.name || '商城'
}

async function fetchTopClassify () {
  const { data: list } = await $api.getClassifyMain()
  list.sort((a, b) => a.sort - b.sort)
  State.topClassify = list.map(data => {
    const { id, name } = data
    return { id, name, link: `/classify/${id}` }
  })
}

try {
  fetchFooter()
  fetchTopClassify()
  fetchCart()
} catch (err) {
  console.log(err)
}

export default bus
